import React from 'react'

// comps
import FooterMainNav from '../Nav/FooterMainNav'
import FooterBtmNav from "../Nav/FooterBtmNav"
import FooterSocialNav from "../Nav/FooterSocialNav"

import "../../assets/styles/layout/footer.scss"

import guidestar from "../../assets/images/guidestar.svg"


export default function Footer() {
  return (
    <div className="footer">
      <div className="top">
        <div className="container no-padding">
          <FooterMainNav />
        </div>
      </div>
      <div className="bottom container">
        <div className="nav-wrapper">
          <FooterBtmNav />
          <FooterSocialNav />
        </div>

        <div className="grid-wrapper">
          <div>
            <img className="guidestar" alt="guidestar" src={guidestar} />
          </div>
          <div className="disclaimer">
            <p>Disclaimer: THIS WEBSITE DOES NOT PROVIDE MEDICAL ADVICE. The information contained on this website is not intended to be a substitute for, or to be relied upon as, medical advice, diagnosis, or treatment. This website is for informational purposes only. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.</p>
            <p>© Copyright 2021 Shatterproof</p>
          </div>
          <div className="address">
            <p>Shatterproof <br />
              101 Merritt 7 Corporate Park, 1st Floor <br />
              Norwalk, CT 06851</p>
          </div>
        </div>
      </div>
    </div>
  )
}
